
/**
 * 뉴스 기본 정보
 */
export type ExploreContentItemContentOneOfFivezeroBasicInfoAllOfTwo = {
  publishedAt: string;
  title: string;
};
